import React from "react";
import { MdDownload, MdImage, MdInsertDriveFile, MdPictureAsPdf, MdTableChart } from "react-icons/md";
import { TicketAttachment } from "../../interfaces/Ticket";
import { tamanhoLegivel } from "../../utils/formatStringUtils";

interface Props {
  anexos: TicketAttachment[];
  /** Equipe e portal baixam por rotas diferentes; quem usa o componente decide qual chamar. */
  onBaixar: (anexo: TicketAttachment) => void;
}

function IconeDoTipo({ contentType, fileName }: { contentType: string; fileName: string }) {
  const cls = "h-4 w-4 shrink-0";
  const nome = fileName.toLowerCase();
  if (contentType.startsWith("image/")) return <MdImage className={cls} aria-hidden="true" />;
  if (contentType === "application/pdf" || nome.endsWith(".pdf"))
    return <MdPictureAsPdf className={cls} aria-hidden="true" />;
  if (/\.(xlsx?|csv)$/.test(nome)) return <MdTableChart className={cls} aria-hidden="true" />;
  return <MdInsertDriveFile className={cls} aria-hidden="true" />;
}

/** Chips de anexos já enviados: ícone por tipo, nome, tamanho, autor e baixar. */
const AnexosLista: React.FC<Props> = ({ anexos, onBaixar }) => {
  if (anexos.length === 0) return null;
  return (
    <ul className="flex flex-wrap gap-2">
      {anexos.map((a) => (
        <li key={a.id}>
          <button
            type="button"
            onClick={() => onBaixar(a)}
            aria-label={`Baixar ${a.fileName}`}
            className="flex max-w-[20rem] items-center gap-2 rounded-xl border border-gray-200 bg-white px-2.5 py-1.5 text-left text-xs text-gray-800 transition-all hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-dv-blue-500 dark:border-white/10 dark:bg-navy-900 dark:text-gray-100 dark:hover:bg-navy-700"
          >
            <IconeDoTipo contentType={a.contentType} fileName={a.fileName} />
            <span className="min-w-0">
              <span className="block truncate font-semibold" title={a.fileName}>
                {a.fileName}
              </span>
              <span className="block truncate text-[11px] text-gray-500 dark:text-gray-400">
                {tamanhoLegivel(a.sizeBytes)}
                {a.uploadedByName ? ` · ${a.uploadedByName}` : ""}
              </span>
            </span>
            <MdDownload className="h-4 w-4 shrink-0 text-gray-500 dark:text-gray-400" aria-hidden="true" />
          </button>
        </li>
      ))}
    </ul>
  );
};

export default AnexosLista;
